module.exports = ".itpx-label {\n  font-size: 85%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-details-group/happy-details-group.component.css
// module id = ./src/app/shared/components/happy/happy-details-group/happy-details-group.component.css
// module chunks = main